import { getReferralToken } from '../../auth'

import { IOrderDetailsApiDto } from '../api'

type TOrderHistoryDto = {
    userData: {
        username: string
    }
    id: string
    quote: string
    base: string
    amount_quote: Number
    amount_base: Number
    withdraw_address: string
    created_on: string
    statusName: string
    userRefCode: string
    referralToken: string
}

const mapToOrderHistoryDto = (
    createdOrderData: IOrderDetailsApiDto,
    username: string,
): { mappedOrderDto: TOrderHistoryDto; anonymousAuthToken: string; orderId: string } => {
    const referralToken = getReferralToken() || ''

    const {
        token: anonymousAuthToken,
        unique_reference: orderId,
        amount_quote,
        amount_base,
        pair,
        created_on,
        referral_code,
    } = createdOrderData

    const mappedOrderDto = {
        userData: {
            username,
        },
        id: orderId,
        quote: pair.quote.code,
        base: pair.base.code,
        amount_quote: parseFloat(amount_quote),
        amount_base: parseFloat(amount_base),
        withdraw_address: '',
        created_on,
        statusName: '',
        userRefCode: referral_code?.[0]?.code,
        referralToken,
    }

    return { mappedOrderDto, anonymousAuthToken, orderId }
}

const saveOrderHistory = (orderHistory: TOrderHistoryDto[]) => {
    localStorage.setItem('orderHistory', JSON.stringify(orderHistory))
}

const saveCreatedOrderInStorage = (mappedOrderDto: TOrderHistoryDto) => {
    // Comment: look for order history array on localStorage (if not present create an empty array)
    // and add the order details to top of array
    const orderHistory = localStorage.orderHistory ? JSON.parse(localStorage.orderHistory) : []

    orderHistory.push(mappedOrderDto)
    saveOrderHistory(orderHistory)
}

const getOrderHistory = (): TOrderHistoryDto[] => {
    try {
        return JSON.parse(window.localStorage.orderHistory ?? '[]')
    } catch {
        console.error('Failed to parse orderHistory')
        return []
    }
}

const getOrderIndexOfOrderHistory = (orderId: string, orderHistory = null): number => {
    const orderHistoryInternal = orderHistory || getOrderHistory()
    return orderHistoryInternal.findIndex(e => e.id === orderId)
}

export {
    mapToOrderHistoryDto,
    saveOrderHistory,
    saveCreatedOrderInStorage,
    getOrderHistory,
    getOrderIndexOfOrderHistory,
}
